/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Erfahrungsstufeag11Inputs */



/**

* @param {_Field_Erfahrungsstufeag11Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_erfahrungsstufeag11 = /** @type {((inputs?: _Field_Erfahrungsstufeag11Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Erfahrungsstufeag11Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Erfahrungsstufe AG 1")
});
export { _field_erfahrungsstufeag11 as "_field_erfahrungsstufeAg1" }